import * as type from '../types/signOut';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestSignOut = actionCreator(type.REQUEST_SIGN_OUT);
export var completeSignOut = actionCreator(type.COMPLETE_SIGN_OUT);